import { ActiveLocation } from "features/location";

export const systemRoles = ["developer", "accountmanager", "support", "admin", "supportadmin", "sparkler"];
export const isInternalUser = (location: ActiveLocation) =>
    !!location.authInfo.userRoles?.some((value) => systemRoles.includes(value));
